import db from './db';

// Generic function to save any API response to specified table
export const saveApiResponse = (tableName, id, data) => {
  return new Promise((resolve, reject) => {
    const timestamp = Date.now();
    const jsonData = JSON.stringify(data);
    
    db.transaction(tx => {
      tx.executeSql(
        `INSERT OR REPLACE INTO ${tableName} (id, data, timestamp) VALUES (?, ?, ?);`,
        [id, jsonData, timestamp],
        (_, result) => {
          resolve(result);
        },
        (_, error) => {
          reject(error);
          return true; // Roll back transaction
        }
      );
    });
  });
};

// Generic function to get API response from specified table
export const getApiResponse = (tableName, id) => {
  return new Promise((resolve, reject) => {
    db.transaction(tx => {
      tx.executeSql(
        `SELECT * FROM ${tableName} WHERE id = ?;`,
        [id],
        (_, { rows }) => {
          if (rows.length > 0) {
            const item = rows.item(0);
            resolve({
              data: item?.data && JSON.parse(item.data),
              timestamp: item.timestamp
            });
          } else {
            resolve(null);
          }
        },
        (_, error) => {
          reject(error);
          return true;
        }
      );
    });
  });
};

// Specific helper functions for each API type
export const saveScanBarcode = (products) => saveApiResponse('scan_barcode', 1, products);
export const getScanBarCode = () => getApiResponse('scan_barcode', 1);

export const saveUsers = (users) => saveApiResponse('users', 1, users);
export const getUsers = () => getApiResponse('users', 1);

export const saveOrders = (orders) => saveApiResponse('orders', 1, orders);
export const getOrders = () => getApiResponse('orders', 1);

export const saveProducts = (categories) => saveApiResponse('products', 1, categories);
export const getProducts = () => getApiResponse('products', 1);

export const saveSettings = (settings) => saveApiResponse('settings', 1, settings);
export const getSettings = () => getApiResponse('settings', 1);